/* eslint-disable jsx-a11y/role-supports-aria-props */

import React, { useEffect, useState } from "react";
import { secColorBg } from '~/utils/helpers'
import { useTheme } from '~/contexts/ThemeContext'
import { usePlp } from '~/contexts/PlpContext'
import useFilterHook from "~/utils/use-filtering"

import { aria_btn, cta_link, countnum, plus_btn } from "~/styles/app.module.scss"
import  { nswatch, scolor } from "~/styles/shared/swatches.module.scss"
import * as styles from "~/styles/plp/filters.module.scss"


const Filters = () => {
  const { 
    isMobile, storesData, storesOpen, setStoresOpen, setBlockHeader, 
    locate, setLocate
  } = useTheme()
  const { 
    collection, products, allProducts, allFilters, filters, setFilters, panelClose, 
    onFilter, singPlTiles, currGroup, currGrpId
  } = usePlp()

  const { filter_order } = collection

  const { parse_filters } = useFilterHook()
  
  const [locFilter, setLocFilter] = useState(false)
  const [openGroups, setOpenGroups] = useState(filters.map(x => x.type))
  const [blockKey, setBlockKey] = useState(false)
  const [availFilters, setAvailFilters] = useState({})

  const flat_prods = (prods) => {
    let prodsarr = prods.flat()
    if (prodsarr.find(x => x.hasOwnProperty('data'))) {
      prodsarr = prodsarr.map(x => {
        return x.hasOwnProperty('data') ? x.products : x
      })
      prodsarr = prodsarr.flat()
    }

    if (currGrpId) {
      const pl_ids = prodsarr.map(x => x.product_line.mid)
      const pl_prods = allProducts.filter(x => pl_ids.includes(x.product_line.mid))
      prodsarr = prodsarr.concat(pl_prods)
    }

    return prodsarr.filter(x => x.hasOwnProperty('filters'))
  }

  const color_codes = {
    "blues": "#404f69",
    "greys": "#acb1af",
    "greens": "#97a187",
    "blacks": "#171717",
    "browns": "#ccb898",
    "reds": "#6d272c",
    "whites": "#fafafa",
    "colors": "#d5d7c6",
  }
  const whites = ['#fff','#ffffff','#fafafa','#627583']

  const check_disable = (obj) => {
    const multi_types = ['type','fabric','style']

    if (multi_types.includes(obj.type) && filters.find(x => x.type === obj.type) ) return false
    if ( obj.name ) {
      return !Object.keys(availFilters).includes(obj.type) || !availFilters[obj.type].includes(obj.name)
    } else {
      return !Object.keys(availFilters).includes(obj.type)
    }
  }

  const order_types = (arr) => {
    const withouts = ['gender','style','fabric','color','size']
    const without = arr.filter( x => !withouts.includes(x) )
    const both_genders = allFilters.gender.includes('men') && allFilters.gender.includes('women')
    const order = !both_genders ? [] : ['gender']
    if ( arr.includes('fabric') && currGroup !== 'fabric' ) order.push('fabric')
    if ( arr.includes('color') ) order.push('color')
    if ( arr.includes('size') ) order.push('size')
    if ( arr.includes('style') && currGroup !== 'style' ) order.push('style')
    return order.concat(without)
  }

  if (allFilters.hasOwnProperty('color') && allFilters.color.includes('colors')) {
    allFilters.color.push(...allFilters.color.splice(allFilters.color.indexOf('colors'), 1))
  }

  const sorted_types = allFilters && order_types(Object.keys(allFilters))

  const handleClose = () => {
    panelClose()
  }

  const handleToggle = (type) => {
    const is_open = openGroups.includes(type)
    if ( is_open ) {
      setOpenGroups( openGroups => openGroups.filter( x => x !== type) )
    } else {
      setOpenGroups( openGroups => [...openGroups, type] )
    }
  }

  const handleFilter = (obj) => {
    setBlockHeader(true)
    onFilter(obj);
  }

  const handleClear = () => {
    setFilters(filters => {
      return filters.filter(x => x.type === 'locations')
    })
  }

  const openStores = () => {
    setBlockKey(true)
    setStoresOpen(true)
  }

  const handleClearStores = () => {
    setBlockHeader(true)
    setLocate({
      ...locate,
      currStores: [],
      storeGend: false
    })
  }

  const checkName = (str) => {
    let fixed = str.replace('group','')
    if (fixed === 'style') fixed = 'fit'
    if (str === 'fabricweight') fixed = 'fabric weight'
    if (str === 'sleevelength') fixed = 'sleeve length'
    return fixed
  }

  const checkStoreApplied = () => {
    return locFilter && locFilter.short_name !== 'WH' && locFilter.short_name !== 'DW'
  }

  const productsCount = () => {
    if (!products || products.length < 1) return 0
    const cleaned = products.flat()
    if (cleaned.find(x => x.hasOwnProperty('products')) ) {
      return cleaned.map(x => x.products).flat().length
    }
    return cleaned.length
  }

  const checkText = () => {
    const is_grouped = !!products.flat().find(x => x?.hasOwnProperty('products'))
    const text = (singPlTiles && filters.length < 1) ? 'Style' : 'Product'

    const count = is_grouped 
                  ? products.flat().reduce((sum, group) => sum + group.products.length, 0)
                  : products.flat().length

    return `${text}${count < 2 ? '' : 's'}`
  }

  const handleIntl = () => {
    setLocate({
      ...locate,
      currStores: [],
      storeGend: false,
      shipIntl: !locate.shipIntl
    })
  }

  const alphaSort = (type) => {
    let filters = allFilters[type].filter( x => !!x )
    const sorts = ['fabric','groupfabric','groupstyle']
    
    if (sorts.includes(type)) {
      filters = filters.sort()
    }

    if (type !== 'size') return filters

    const size_order = ['xxs','2s','xs','s','m','l','xl','xxl','2x','xxxl','3x','os','one size']
    let str_sizes = filters.filter(x => !Number.isInteger(Number(x)) && !x.includes('.'))
    str_sizes = str_sizes.sort((a, b) => size_order.indexOf(a.toLowerCase()) - size_order.indexOf(b.toLowerCase()) )

    let int_sizes = filters.filter(x => Number.isInteger(Number(x)) || x.includes('.'))
    int_sizes = int_sizes.sort((a, b) => parseFloat(a) - parseFloat(b));

    return str_sizes.concat(int_sizes)
  }

  useEffect(() => {
    if (products.flat().length < 1) return

    if (filters.length < 1 && !currGrpId) {
      setAvailFilters(allFilters)
      return
    }

    const new_avail = parse_filters(flat_prods(products), filter_order)
    setAvailFilters(new_avail)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products])

  useEffect(() => {
    const filtersListen = (e) => {
      if (blockKey) return
      if (e.key === 'Escape') {
        window.removeEventListener('keydown', filtersListen)
        handleClose()
      }
    }
    if (!isMobile) window.addEventListener('keydown', filtersListen)

    return () => {
      window.removeEventListener('keydown', filtersListen)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockKey])

  useEffect(() => {
    if (blockKey && !storesOpen) setBlockKey(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesOpen, blockKey])

  useEffect(() => {
    if (storesData.length < 1) return
    let needs_set = !locFilter
    if (!!locFilter && locate?.currStores?.length > 0) {
      needs_set = locate.currStores[0] !== locFilter.short_name
    }

    if (locate?.currStores.length > 0 && needs_set) {
      const short = locate.currStores[0]
      const store = storesData.flatMap(x => x.stores).find(x => x.short_name === short)
      setLocFilter({short_name: short, title: store?.title || ''})
    }
    if (!!locFilter && locate?.currStores.length < 1) {
      setLocFilter(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, storesData, locate])

  

  return (
    <>
      <div className={styles.filters_wr} filters-wr="">
        <div className={[styles.filt_title].join(' ')}>
          Filter <span filts-cnt=""></span>
        </div>
        <div className={styles.filt_stores}>
          <div className={styles.toggle} storeloc-toggle="">
            <label className={styles.nswitch} switch-box="" htmlFor="coll-shop_stores">
              <input 
                id="coll-shop_stores"
                type="checkbox" 
                className={styles.nswitch_input} 
                checked={checkStoreApplied() ? 'checked' : false}
                aria-label="Shop by Store" 
                tabIndex="-1"
                aria-selected={checkStoreApplied() ? 'true' : 'false'}
                onChange={(e)=>{ checkStoreApplied() ? handleClearStores() : openStores() }}
              />
            </label>
          </div>
          <div className={styles.label}>
            Pick up in Store today
          </div>
          <button 
            type="button"
            className={`aria_btn ${styles.store_curr}`}
            coll-store-curr="" 
            data-uipop-btn="stores"
            tabIndex="-1" 
            aria-label={'Find a store'}
            onClick={(e)=>{ openStores() }}
          >
            {checkStoreApplied() ? `Store: ${locFilter.title}` : 'Find a Store'}
          </button>

          {(locate?.country !== 'US') && (
            <div className={styles.intl}>
              <button 
                type="button"
                className={`${aria_btn} ${styles.option}`} 
                aria-pressed={locate?.shipIntl ? 'true' : 'false'}
                onClick={(e)=>{handleIntl()}}
              >
                <div className={styles.name}>Ships International</div>
              </button>
            </div>
          )}
        </div>

        <ul className={`aria_btn ${styles.filters}`}>
          {sorted_types && sorted_types.map( (type) => 
            <li key={type}>
              <button 
                type="button"
                id={`nfiltg-${type}`}
                className={`${aria_btn} ${styles.type} ${plus_btn} ${check_disable({type: type, name: false}) ? styles.disabled : ''}`}
                onClick={(e)=> { handleToggle(type) }}
                aria-expanded={openGroups.includes(type) ? 'true' : 'false'}
                aria-controls={`nfiltp-${type}`} 
              >
                <span>{checkName(type)}</span>
                {filters.find( x => x.type === type) && (
                  <span className={countnum}>
                    ({filters.filter( x => x.type === type).length})
                  </span>
                )}
              </button>
              {openGroups.includes(type) && (
                <div 
                  id={`nfiltp-${type}`} 
                  className={styles.options}
                  aria-labelledby={`nfiltg-${type}`}
                  role="region"
                >
                  {alphaSort(type).map( (filter) => {
                    let fe_name = filter.replace('womens-','').split('--')[0]
                    let color_code 
                    let is_white
                    if ( type === 'color' ) {
                      color_code = color_codes[filter] && color_codes[filter].toLowerCase()
                      is_white = !color_code || whites.includes(color_code)
                    } 
                    const filterObj = {type: type, name: filter}

                    let sec_color = ''
                    if (fe_name === 'colors') {
                      fe_name = 'Other / Multiple'
                      sec_color = `scolor-filts ${scolor}`
                    }
                    if (fe_name.toLowerCase() === 'os') {
                      fe_name = 'One Size'
                    }

                    return (
                      <React.Fragment key={`${type}${filter}`}>
                        {type === 'color' ? (
                          <button 
                            type="button"
                            className={[aria_btn, styles.option].join(' ')}
                            aria-pressed={filters.find( x => x.type === type && x.name === filter) ? 'true' : 'false'} 
                            onClick={(e)=> { handleFilter(filterObj) }}
                            disabled={check_disable(filterObj) ? 'disabled' : undefined}
                            aria-disabled={check_disable(filterObj) ? 'true' : undefined}
                          >
                            {sec_color && (
                              <style dangerouslySetInnerHTML={{ __html: `.scolor-filts:after {background-image: ${secColorBg('#566e83') };}` }} />
                            )}
                            <div 
                              className={[nswatch, sec_color].join(' ')} 
                              style={{backgroundColor: color_code, border: is_white ? '1px solid #666' : ''}}
                            ></div>
                            <div className={styles.name}>{fe_name}</div>
                          </button>
                        ) : (
                          <button 
                            type="button"
                            className={`${aria_btn} ${styles.option}`}
                            aria-pressed={filters.find( x => x.type === type && x.name === filter) ? 'true' : 'false'} 
                            onClick={(e)=> { handleFilter(filterObj) }}
                            disabled={check_disable(filterObj) ? 'disabled' : undefined}
                            aria-disabled={check_disable(filterObj) ? 'true' : undefined}
                          >
                            <div className={styles.name}>{fe_name}</div>
                          </button>
                        )}
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </li>
          )}
          {(locate?.country === 'US') && (
            <li className={styles.intl}>
              <button 
                type="button"
                className={`${aria_btn} ${styles.option}`} 
                aria-pressed={locate?.shipIntl ? 'true' : 'false'}
                onClick={(e)=>{handleIntl()}}
              >
                <div className={styles.name}>Ships International</div>
              </button>
            </li>
          )}
        </ul>
        

        <div className={[styles.filt_close].join(' ')}>
          {filters.length > 0 && (
            <button type="button" className={`aria_btn ${cta_link}`} style={{float: 'left'}} onClick={(e) => handleClear()}>
              <span>Clear</span>
            </button>
          )}
          <button className="aria_btn" onClick={(e)=> {handleClose()}}>
            {(filters.length > 0 || checkStoreApplied()) ? (
              <>
                <span>View {`${productsCount()} ${checkText()}`}</span>
              </>
            ) : (
              <span>Close</span>
            )}
          </button>
        </div>
      </div>
    </>
  )
};

export default Filters
